// extracted by mini-css-extract-plugin
export default {"flex":"Portal_flex__njA9t","center":"Portal_center__xnSxn","selection":"Portal_selection__VwwYN"};